<template>
    <div class="sc-message-list" ref="scrollList" @scroll="handleScroll" :style="{ backgroundColor: chatbotColors.messageList.bg }">
      <Message
        v-for="(message, idx) in messages"
        :message="message"
        :key="`message-${idx}`"
        :lastMessage="idx === Object.keys(messages).length - 1"
        :chatbotColors="chatbotColors"
        :chatbotName="chatbotName"
        :chatbotImage="chatbotImage"
        :messageStyling="messageStyling" />

      <Message
        v-show="showTypingIndicator !== ''"
        :message="{author: showTypingIndicator, type: 'typing'}"
        :chatbotColors="chatbotColors"
        :chatbotName="chatbotName"
        :chatbotImage="chatbotImage"
        :messageStyling="messageStyling" />
    </div>
</template>
<script>
import Message from './Message.vue'
import chatIcon from './assets/robocote2.png'

export default {
  components: {
    Message
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotName: {
      type: String,
      required: true
    },
    chatbotImage: {
      type: String,
      default: ''
    },
  },
  computed: {
    defaultChatIcon() {
      return chatIcon
    }
  },
  methods: {
    _scrollDown () {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight
    },
    handleScroll (e) {
      if (e.target.scrollTop === 0) {
        this.$emit('scrollToTop')
      }
    },
    shouldScrollToBottom() {
      return this.alwaysScrollToBottom; //|| (this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600)
    }
  },
  mounted () {
    this.$nextTick(this._scrollDown);
    setTimeout(this._scrollDown, 500);

    window.EventBus.$on('OVERLAP_SHOWED', this._scrollDown);
  },
  updated () {
    if (this.shouldScrollToBottom()) {
      this.$nextTick(this._scrollDown);
      setTimeout(this._scrollDown, 500);
    }
  }
}
</script>

<style scoped>
.sc-message-list {
  position: relative;
  background-size: 100%;
  height: 80%;
  overflow-y: auto;
  padding: 40px 0px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
